<template>
    <div class="active_table">
        <toolbar>
            <div class="search">
                <i-input prefix="ios-search" placeholder="输入站点名称查询" v-model="search.name" style="width: auto" />
                <i-button type="default" @click="getData" style="margin-left: 1em;">搜索</i-button>
            </div>
            <div class="active">
                <i-button type="primary" @click="addData">添加</i-button>
                <i-button type="error" style="margin-left: 1em;">批量删除</i-button>
            </div>
        </toolbar>
        <div class="table">
            <i-table border :columns="table.columns" :data="table.data"></i-table>
            <Page :total="table.total" show-sizer @on-change="pageCurrentChange($event)"
                @on-page-size-change="pageSizeChange($event)" style="text-align:right;margin-top: 1em" />
            <Spin fix v-show="table.loading"></Spin>
        </div>

        <!-- 表单对话框 -->
        <Modal :title="modal.title" v-model="modal.show" :mask-closable="false">
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
                <FormItem label="站点编号：" prop="mn">
                    <!-- <i-input v-model="formValidate.mn" :disabled="modal.siteAble" placeholder="输入站点编号"></i-input> -->
                    <i-input v-model="formValidate.mn" placeholder="输入站点编号"></i-input>
                </FormItem>
                <FormItem label="名称：" prop="name">
                    <i-input v-model="formValidate.name" placeholder="输入名称"></i-input>
                </FormItem>

                <!-- 设备配置 -->
                <FormItem label="选择设备：" v-if="modal.title == '更新'">
                    <Select v-model="deviceCheck" multiple @on-change="deviceCheckChange($event)">
                        <Option v-for="item in deviceList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <FormItem label="处 理 量：">
                    <i-input v-model="formValidate.airflow" placeholder="输入处理量"></i-input>
                </FormItem>
                <FormItem label="处理对象：">
                    <i-input v-model="formValidate.processingObject" placeholder="输入处理对象"></i-input>
                </FormItem>
                <FormItem label="处理工艺：">
                    <i-input v-model="formValidate.processingTreatment" placeholder="输入处理工艺"></i-input>
                </FormItem>
                <FormItem label="排放标准：">
                    <i-input v-model="formValidate.emissionStandard" placeholder="输入排放标准"></i-input>
                </FormItem>

                <FormItem label="配图：">
                    <div class="form_upload">
                        <LoadImg :imgUrl="formValidate.imgUrl" @close="imgLoadDel" @success="imgLoadSuccess($event)">
                        </LoadImg>
                    </div>
                </FormItem>

                <FormItem label="站点监测图：">
                    <div class="form_upload">
                        <LoadImg :imgUrl="formValidate.fullPicUrl" @close="fullPicLoadDel"
                            @success="fullPicLoadSuccess($event)"></LoadImg>
                    </div>
                </FormItem>
                <FormItem label="x坐标：" prop="imgUrlX">
                    <i-input v-model="formValidate.imgUrlX" placeholder="输入站点x坐标"></i-input>
                </FormItem>
                <FormItem label="Y坐标：" prop="imgUrlY">
                    <i-input v-model="formValidate.imgUrlY" placeholder="输入站点y坐标"></i-input>
                </FormItem>
                <FormItem label="经度：">
                    <i-input v-model="formValidate.longitude" placeholder="输入站点经度"></i-input>
                </FormItem>
                <FormItem label="纬度：">
                    <i-input v-model="formValidate.latitude" placeholder="输入站点纬度"></i-input>
                </FormItem>
                <!-- <FormItem label="负责人：">
                    <Select v-model="formValidate.managerIdList" multiple>
                        <Option v-for="item in userList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem> -->
                <FormItem label="负责人：">
                    <div style="display: flex;align-items: center;margin-bottom: 10px;"
                        v-for="(item, index) in formValidate.managerInfo" :key="index">
                        <i-input placeholder="输入负责人姓名" v-model="item.name"
                            style="width: 60%;margin-right: 10px;"></i-input>
                        <i-button type="default" style="height: 32px;" @click="addInput()">
                            <Icon type="md-add" />
                        </i-button>
                        <i-button type="default" style="height: 32px;margin-left: 10px;" @click="removeInput(index)"
                            v-if="index != 0">
                            <Icon type="md-close" />
                        </i-button>
                    </div>
                </FormItem>
                <FormItem label="告警邮件：">
                    <RadioGroup v-model="formValidate.message">
                        <Radio label="true">是</Radio>
                        <Radio label="false">否</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="环保设施：" prop="environmentalFacilities">
                    <i-input v-model="formValidate.environmentalFacilities" type="textarea" :rows="2"
                        placeholder="输入详情介绍"></i-input>
                </FormItem>
                <FormItem label="详情介绍：" prop="remark">
                    <i-input v-model="formValidate.remark" type="textarea" :rows="2" placeholder="输入详情介绍"></i-input>
                </FormItem>
                <FormItem label="索引位置：">
                    <i-input v-model="formValidate.index" placeholder="默认0，排在第一"></i-input>
                </FormItem>
                <FormItem label="巡检周期：">
                    <i-input v-model="formValidate.inspectionCycle" placeholder="默认1天"></i-input>
                </FormItem>
            </Form>

            <div slot="footer">
                <i-button type="primary" @click="activeData">{{ modal.title }}</i-button>
                <i-button style="margin-left: 1em;" @click="modal.show = false">取消</i-button>
            </div>
        </Modal>

        <!-- 提示对话框 -->
        <alert-p :modalAlert="alert.show" title="警告提醒" content="确定要删除吗？" @cansel="alert.show = false"
            @makeSure="delData" :modal_loading="alert.loading"></alert-p>
    </div>
</template>

<style lang="scss" scoped>
.active_table {
    width: 100%;
    height: 100%;
}

.table {
    padding: 0 1em;
    width: 100%;
    height: calc(100% - 7.5em);
    position: relative;
}
</style>

<script>
import toolbar from "../toolBar.vue";
import { timeStamp } from "../../../util/common/date";
import LoadImg from "../../../components/Load_img.vue";

export default {
    data() {
        return {
            // 表格
            table: {
                // 表格属性
                columns: [
                    {
                        type: "selection",
                        width: 60,
                        align: "center"
                    },
                    {
                        title: "站点名称",
                        key: "name",
                        align: "center"
                    },

                    {
                        title: "工艺图",
                        key: "picUrl",
                        align: "center",
                        render(h, params) {
                            return h(
                                "div",
                                {
                                    style: {
                                        height: "50px",
                                        overflow: "hidden"
                                    }
                                },
                                [
                                    h("vImage", {
                                        // attrs: {
                                        //   src: params.row.imgUrl
                                        // },
                                        props: {
                                            imgUrl: params.row.imgUrl
                                        }
                                    })
                                ]
                            );
                        }
                    },
                    {
                        title: "状态",
                        key: "statusName",
                        align: "center"
                    },
                    {
                        title: "告警邮件",
                        key: "message",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h("i-switch", {
                                    props: {
                                        size: "large",
                                        value: params.row.message,
                                        loading: this.table.isSystem_loading
                                    },
                                    // scopedSlots: {
                                    //     open: () => h("span", "禁用"),
                                    //     close: () => h("span", "开启")
                                    // },
                                    on: {
                                        "on-change": value => {
                                            // 是否启用切换
                                            this.table.isSystem_loading = true; // 开启loading
                                            // console.log(params.row)
                                            this.$api.Deploy.postSiteEdit(
                                                {
                                                    content: { id: params.row.id, isMessage: value, mn: params.row.mn }
                                                },
                                                ["uuid", "company"]
                                            )
                                                .then(res => {
                                                    if (res.code == 0) {
                                                        this.table.isSystem_loading = false;
                                                        this.$Message.success("切换成功");
                                                    } else {
                                                        this.table.isSystem_loading = false;
                                                        this.$Message.warning(res.message);
                                                    }
                                                })
                                                .catch(err => {
                                                    this.table.isSystem_loading = false;
                                                });
                                        }
                                    }
                                })
                            ]);
                        }
                    },
                    {
                        title: "正在运维",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h("i-switch", {
                                    props: {
                                        size: "large",
                                        value: params.row.inMaintenance,
                                        loading: this.table.inMaintenance_loading
                                    },
                                    // scopedSlots: {
                                    //     open: () => h("span", "运维"),
                                    //     close: () => h("span", "正常")
                                    // },
                                    on: {
                                        "on-change": value => {
                                            // 是否启用切换
                                            this.table.inMaintenance_loading = true; // 开启loading
                                            this.$api.Deploy.postSiteEdit(
                                                {
                                                    content: { id: params.row.id, inMaintenance: value, mn: params.row.mn }
                                                },
                                                ["uuid", "company"]
                                            )
                                                .then(res => {
                                                    if (res.code == 0) {
                                                        this.table.inMaintenance_loading = false;
                                                        this.$Message.success("切换成功");
                                                    } else {
                                                        this.table.inMaintenance_loading = false;
                                                        this.$Message.warning(res.message);
                                                    }
                                                })
                                                .catch(err => {
                                                    this.table.inMaintenance_loading = false;
                                                });
                                        }
                                    }
                                })
                            ]);
                        }
                    },
                    {
                        title: "创建时间",
                        key: "createDate",
                        align: "center",
                        render(h, params) {
                            return h("span", {}, timeStamp(params.row.createDate));
                        }
                    },
                    {
                        title: "操作",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "i-button",
                                    {
                                        props: {
                                            type: "warning",
                                            size: "small"
                                        },
                                        style: {
                                            marginRight: "5px"
                                        },
                                        on: {
                                            click: () => {
                                                this.modal.title = "更新";
                                                this.modal.show = true;
                                                this.$refs.formValidate.resetFields(); // 清除验证错误

                                                // 通过站点获取站点设备列表
                                                this.deviceList = this.allDeviceList[params.row.mn];
                                                // 将字符串转换为数组 绑定设备数据
                                                if (params.row.masterDevices) {
                                                    this.deviceCheck = params.row.masterDevices.split(
                                                        ","
                                                    );
                                                    for (
                                                        let i = 0, length = this.deviceCheck.length;
                                                        i < length;
                                                        i++
                                                    ) {
                                                        this.deviceCheck[i] = parseInt(this.deviceCheck[i]);
                                                    }
                                                }
                                                this.modal.siteAble = true;
                                                this.formValidate = {
                                                    id: params.row.id,
                                                    mn: params.row.mn, // 站点编号 必填
                                                    name: params.row.name, // 站点名称 必填
                                                    imgUrl: params.row.imgUrl, // 配图 选填
                                                    fullPicUrl: params.row.fullPicUrl, // 配图 选填
                                                    imgUrlX: params.row.imgUrlX, // 配图定位X 选填
                                                    imgUrlY: params.row.imgUrlY, // 配图定位Y 选填
                                                    remark: params.row.remark, // 详情介绍 选填
                                                    environmentalFacilities: params.row.environmentalFacilities, //环保设施
                                                    message: params.row.message + "", // 告警邮件 必填
                                                    processingObject: params.row.processingObject, // 处理对象 选填
                                                    airflow: params.row.airflow, // 气流 选填
                                                    processingTreatment: params.row.processingTreatment, // 加工处理 选填
                                                    emissionStandard: params.row.emissionStandard, // 排放标准 选填
                                                    longitude: params.row.longitude, // 经度 选填
                                                    latitude: params.row.latitude, // 纬度 选填
                                                    managerIdList: params.row.managerIdList, // 负责人 必填
                                                    index: params.row.index, // 站点编号 选填
                                                    inspectionCycle: params.row.inspectionCycle, //巡检周期（单位是天）
                                                    managerInfo: (() => {
                                                        if (!params.row.managerInfo) {
                                                            return [{ name: null }];
                                                        }

                                                        try {
                                                            return JSON.parse(params.row.managerInfo);
                                                        } catch (error) {
                                                            console.error('Error parsing managerInfo JSON:', error);
                                                            return [{ name: null }];
                                                        }
                                                    })()
                                                };
                                                //console.log(this.formValidate)
                                            }
                                        }
                                    },
                                    "编辑"
                                ),
                                h(
                                    "i-button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small"
                                        },
                                        on: {
                                            click: () => {
                                                this.alert.id = params.row.id;
                                                this.alert.show = true;
                                            }
                                        }
                                    },
                                    "删除"
                                )
                            ]);
                        }
                    }
                ],
                data: [],
                pageCurrent: 1,
                pageSize: 10,

                total: 0,
                loading: true,
                isSystem_loading: false, // 切换启用状态loading
                inMaintenance_loading: false // 切换运维状态
            },
            // 查询
            search: {
                name: null
            },
            // 表单
            modal: {
                show: false,
                title: "添加",
                siteAble: false
            },
            // 表单数据
            formValidate: {
                index: "0", // 排序用
                mn: "", // 站点编号 必填
                name: null, // 站点名称 必填
                fullPicUrl: "", // 配图 选填
                imgUrl: "", // 配图 选填
                imgUrlX: "", // 配图定位X 选填
                imgUrlY: "", // 配图定位Y 选填
                remark: "", // 详情介绍 选填
                environmentalFacilities: "",//环保设施
                message: "", // 告警邮件 必填
                processingObject: "", // 处理对象 选填
                airflow: "", // 气流 选填
                processingTreatment: "", // 加工处理 选填
                emissionStandard: "", // 排放标准 选填
                longitude: "", // 经度 选填
                latitude: "", // 纬度 选填
                inspectionCycle: 1, // 巡检周期 选填
                managerIdList: [1], // 负责人 必填 替换
                managerInfo: []  // 负责人 新字段
            },
            // 用户列表
            userList: [],
            // 所有设备列表
            allDeviceList: [],
            // 站点对应设备列表
            deviceList: [],
            // 已选设备
            deviceCheck: [],
            // 验证
            ruleValidate: {
                mn: [{ required: true, message: "不能为空", trigger: "blur" }],
                name: [{ required: true, message: "不能为空", trigger: "blur" }],
                message: [{ required: true, message: "不能为空", trigger: "change" }],
                managerIdList: [
                    { required: true, message: "不能为空", trigger: "blur" }
                ]
            },
            // alert提示组件
            alert: {
                show: false,
                loading: false,
                id: ""
            }
        };
    },
    components: {
        toolbar,
        LoadImg
    },
    created() {
        this.getData(); // 数据初始化
        this.getUserList();
        this.getDeviceList();
    },
    computed: {},
    methods: {
        addData() {
            // 打开表单添加
            this.modal.title = "添加";
            this.modal.show = true;
            this.modal.siteAble = false;
            this.formValidate = {
                index: "0", // 排序用 选填
                mn: "", // 站点编号 必填
                name: null, // 站点名称 必填
                imgUrl: "", // 配图 选填
                imgUrlX: "", // 配图定位X 选填
                imgUrlY: "", // 配图定位Y 选填
                remark: "", // 详情介绍 选填
                environmentalFacilities: "", //环保设施
                message: "", // 告警邮件 必填
                processingObject: "", // 处理对象 选填
                airflow: "", // 气流 选填
                processingTreatment: "", // 加工处理 选填
                emissionStandard: "", // 排放标准 选填
                longitude: "", // 经度 选填
                latitude: "", // 纬度 选填
                inspectionCycle: 1, // 巡检周期 选填
                managerIdList: [], // 负责人 必填
                managerInfo: [{
                    name: null
                }]  // 负责人 新字段
            };
            this.$refs.formValidate.resetFields(); // 清除验证错误
        },
        getData() {
            // 获取数据
            this.table.loading = true;
            this.$api.Deploy.getSiteList(
                {
                    pageCurrent: this.table.pageCurrent,
                    pageSize: this.table.pageSize,
                    content: this.search
                },
                ["uuid", "company"]
            ).then(res => {
                if (res.code == 0) {
                    // 获取成功
                    this.table.data = res.data.list;
                    this.table.total = res.data.total;
                    this.table.loading = false;
                    this.$Message.success("加载完成");
                } else {
                    this.$Message.warning(res.message);
                    this.table.loading = false;
                }
            });
        },
        getUserList() {
            // 获取用户列表
            this.$api.System.getUserList({ pageCurrent: 1, pageSize: 40 }, [
                "uuid",
                "company"
            ]).then(res => {
                if (res.code == 0) {
                    this.userList = res.data.list;
                } else {
                    this.$Notice.warning({
                        title: "接口异常",
                        desc: `返回：${res.message || "没有返回"}`
                    });
                }
            });
        },
        // 获取所有设备
        getDeviceList() {
            this.$api.Enum.getDeviceEnum(null, ["uuid", "company"]).then(res => {
                if (res.code == 0) {
                    let data = res.data;
                    let siteMap = {};
                    //console.log(res);
                    data.map(item => {
                        if (!siteMap[item.mn]) {
                            siteMap[item.mn] = [];
                        } else {
                            siteMap[item.mn].push(item);
                        }
                    });
                    this.allDeviceList = siteMap;
                }
            });
        },
        delData() {
            // 删除数据
            let id = this.alert.id; // 点击删除时对应的id
            if (id) {
                // 删
                this.alert.loading = true;
                this.$api.Deploy.getSiteDel({ content: { id: id } }, [
                    "uuid",
                    "company"
                ])
                    .then(res => {
                        this.alert.show = false;
                        if (res.code == 0) {
                            this.alert.loading = false;
                            this.$Notice.success({
                                title: "删除成功",
                                desc: ""
                            });
                            this.getData();
                        } else {
                            this.alert.loading = false;
                            this.$Notice.warning({
                                title: "删除失败",
                                desc: res.message ? res.message : "请联系管理员"
                            });
                        }
                    })
                    .catch(err => {
                        this.alert.show = false;
                        this.alert.loading = false;
                    });
            } else {
                // 不存在id说明异常
                this.alert.show = false;
                this.$Notice.warning({
                    title: "删除失败",
                    desc: "数据异常，请联系管理员"
                });
            }
        },
        pageCurrentChange(num) {
            // 页码跳转
            this.table.pageCurrent = num;
            this.getData();
        },
        pageSizeChange(num) {
            // 每页数量切换
            this.table.pageSize = num;
            this.getData();
        },
        activeData() {
            //增、改操作
            this.$refs.formValidate.validate(valid => {
                if (valid) {
                    let params = this.formValidate;
                    params.managerInfo = JSON.stringify(params.managerInfo);
                    // 表单验证是否通过
                    if (this.modal.title == "添加") {
                        this.$api.Deploy.postSiteAdd({ content: params }, [
                            "uuid",
                            "company"
                        ]).then(res => {
                            if (res.code == 0) {
                                this.$Notice.success({
                                    title: "添加成功",
                                    desc: "添加成功，正在刷新数据..."
                                });
                                this.modal.show = false;
                                this.getData();
                            } else {
                                this.$Notice.warning({
                                    title: "添加失败",
                                    desc: res.message || "请联系管理员"
                                });
                            }
                        });
                    } else {
                        this.$api.Deploy.postSiteEdit({ content: params }, [
                            "uuid",
                            "company"
                        ]).then(res => {
                            if (res.code == 0) {
                                this.$Notice.success({
                                    title: "更新成功",
                                    desc: "更新成功，正在刷新数据..."
                                });
                                this.modal.show = false;
                                this.getData();
                            } else {
                                this.$Notice.warning({
                                    title: "更新失败",
                                    desc: res.message || "请联系管理员"
                                });
                            }
                        });
                    }
                }
            });
        },
        // 绑定设备发生变化时 对表单重新赋值
        deviceCheckChange(array) {
            this.formValidate.masterDevices = array.join();
        },
        imgLoadSuccess(url) {
            // img回调
            this.formValidate.imgUrl = url;
        },
        fullPicLoadSuccess(url) {
            // img回调
            this.formValidate.fullPicUrl = url;
        },
        // img删除回调
        imgLoadDel() {
            this.formValidate.imgUrl = null;
        },
        fullPicLoadDel() {
            this.formValidate.fullPicUrl = null;
        },
        // 添加负责人输入框
        addInput() {
            this.formValidate.managerInfo.push({
                name: null
            });
        },
        // 删除负责人输入框
        removeInput(index) {
            this.formValidate.managerInfo.splice(index, 1);
        }
    }
};
</script>